const createToggleHandler = (allOptions: string[], current: string[], setter: (value: string[]) => void) => (value: string[]) => {
  if (value.includes('all')) {
    setter(current.length === allOptions.length ? [] : allOptions);
  } else {
    setter(value);
  }
};

export default createToggleHandler;
